import { Link } from "react-router-dom";
import Box from "../shared/Box";
import "../../styles/footer.scss";

const Footer = () => {
  return (
    <>
      <Box className="footer_top">
        <div className="footer_links_conatiner">
          <FooterLogo />
          <FooterLinks
            title={"Links"}
            links={[
              {
                title: "Home",
                href: "/",
              },

              {
                title: "How It Works",
                href: "/how-it-works",
              },
              {
                title: " Key Industries  ",
                href: "/use-cases",
              },
              {
                title: "Features & Apps",
                href: "/key-features",
              },
              {
                title: "Players",
                href: "/players",
              },
              {
                title: "Pricing",
                href: "/pricing",
              },
              // {
              //   title: "Careers",
              //   href: "/",
              // },
              // {
              //   title: "Blogs",
              //   href: "/",
              // },
            ]}
          />
        </div>
        {/* <FooterLinks
          title={"Help & Support"}
          links={[
            {
              title: "Support",
              href: "/",
            },
            {
              title: "FAQ",
              href: "/",
            },
            {
              title: "Privacy",
              href: "/",
            },
            {
              title: "Request a Demo",
              href: "/contact",
            },
          ]}
        /> */}
        <FooterContacts />
      </Box>
      <div className="footer_bottom">
        <p>
          Optimized and developed by{" "}
          <a
            href="https://edensolutions.tech/"
            target="_blank"
            rel="noreferrer"
          >
            Eden Solutions
          </a>
          . All Rights reserved for <Link to={"/"}>Shasha</Link>.
          {/* @2023 <Link to={"/"}>Shasha</Link>. All rights reserved. */}
        </p>
      </div>
    </>
  );
};

export default Footer;

const FooterLogo = () => {
  return (
    <div className="footer_larg footer_logo">
      <div className="footer_logo_img">
        <Link to={"/"}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 75 61"
            fill="none"
          >
            <path
              d="M31.0268 7.85669C41.2016 7.85635 51.3764 7.85635 61.5513 7.85635C62.0881 7.85635 62.0884 7.85668 62.0884 8.38044C62.0884 9.96275 62.0807 11.5454 62.0951 13.1277C62.0978 13.4277 62.0085 13.5184 61.7135 13.5073C61.1489 13.4866 60.583 13.4929 60.0178 13.505C59.7867 13.51 59.7154 13.427 59.7181 13.1996C59.7282 12.3203 59.7134 11.441 59.7271 10.5621C59.7312 10.3066 59.6663 10.1822 59.3947 10.221C59.3208 10.2317 59.2442 10.2223 59.1686 10.2223C40.4143 10.2226 21.66 10.2223 2.90542 10.2236C2.30273 10.2236 2.36026 10.1507 2.36026 10.7654C2.35925 23.7015 2.35925 36.6376 2.36026 49.5734C2.36026 50.2045 2.30942 50.1119 2.90575 50.1122C21.5972 50.1135 40.2886 50.1135 58.9803 50.1122C59.5522 50.1122 59.5034 50.1955 59.5034 49.5914C59.5047 43.613 59.5074 37.635 59.497 31.6566C59.4964 31.3087 59.5589 31.1669 59.9419 31.1937C60.467 31.2308 60.9971 31.2174 61.5238 31.197C61.7941 31.1867 61.9101 31.2452 61.8854 31.5429C61.8573 31.8797 61.8787 32.2205 61.8787 32.5596C61.8787 39.04 61.876 45.5208 61.8864 52.0012C61.8867 52.345 61.8315 52.4668 61.4476 52.4664C41.1103 52.4554 20.7734 52.4557 0.436132 52.4634C0.098331 52.4634 0.00100333 52.3845 0.00133779 52.034C0.0107026 37.4527 0.0110377 22.8714 6.96504e-07 8.29014C-0.000333759 7.90685 0.119736 7.84933 0.46456 7.84966C10.6521 7.85869 20.8393 7.85702 31.0268 7.85669Z"
              fill="#8D8CC4"
            />
            <path
              d="M74.7136 30.6262C74.7136 40.5736 74.7136 50.521 74.7136 60.468C74.7136 60.9991 74.7133 60.9998 74.1919 60.9998C61.2407 60.9998 48.2893 60.9998 35.3378 60.9998C34.797 60.9998 34.7966 60.9991 34.7966 60.4459C34.7966 58.6623 34.81 56.8786 34.7873 55.0953C34.7819 54.702 34.9003 54.606 35.2716 54.6298C35.7846 54.6622 36.302 54.6568 36.8158 54.6304C37.1124 54.6154 37.1653 54.7231 37.1619 54.993C37.1472 56.0853 37.1676 57.1783 37.1482 58.2706C37.1429 58.5747 37.2368 58.6399 37.5258 58.6399C49.0073 58.6329 60.4892 58.6319 71.9708 58.6429C72.3223 58.6432 72.3731 58.5325 72.3728 58.2198C72.3641 51.915 72.3661 45.6098 72.3661 39.305C72.3661 27.2351 72.3664 15.1653 72.3647 3.0951C72.3647 2.55563 72.454 2.59944 71.8574 2.59944C60.4511 2.59843 49.0448 2.59844 37.6385 2.59877C37.1559 2.59877 37.1559 2.59944 37.1559 3.08273C37.1556 3.83626 37.1455 4.59013 37.1612 5.34332C37.1666 5.59517 37.0843 5.66239 36.8422 5.65604C36.2649 5.64032 35.6866 5.64366 35.109 5.65436C34.8953 5.65837 34.7913 5.61623 34.7926 5.36907C34.8017 3.74897 34.7997 2.12852 34.794 0.508423C34.7933 0.301727 34.8525 0.200054 35.0722 0.228817C35.1462 0.238518 35.2227 0.230152 35.298 0.230152C48.2746 0.230152 61.2511 0.22982 74.2277 0.231159C74.7571 0.231495 74.7126 0.148216 74.7126 0.708767C74.714 10.6812 74.7136 20.6537 74.7136 30.6262Z"
              fill="#8D8CC4"
            />
            <path
              d="M44.7409 28.6108C44.7081 28.6094 44.675 28.6084 44.6422 28.6071C44.0626 31.6416 43.3224 34.64 42.594 37.6374C42.7485 37.712 42.8883 37.6822 43.0234 37.6826C44.1285 37.6852 45.2338 37.6842 46.3392 37.6839C46.8152 37.6839 46.8145 37.6839 46.7024 37.2347C46.2001 35.2189 45.7195 33.1985 45.2843 31.1673C45.1017 30.3155 44.9218 29.463 44.7409 28.6108ZM23.7223 34.5858C23.7444 34.4507 23.6578 34.4209 23.6069 34.3755C22.3042 33.2132 21.8002 31.7018 21.6895 30.0158C21.6667 29.6713 21.7891 29.5028 22.1617 29.5258C22.5373 29.5493 22.9153 29.5288 23.2922 29.5315C23.7661 29.5345 23.8568 29.6188 23.8892 30.0991C23.9337 30.7586 24.0942 31.3874 24.3962 31.9751C25.0805 33.3065 26.2662 33.8674 28.0067 33.6932C29.3184 33.5617 30.371 32.7035 30.7241 31.4771C31.1663 29.9422 30.6445 28.3853 29.3639 27.4208C28.4201 26.7101 27.304 26.3391 26.2478 25.8518C25.3601 25.4425 24.4491 25.0792 23.6885 24.4408C21.9778 23.0043 21.532 21.1581 22.0708 19.0724C22.5972 17.0356 24.0708 15.9667 26.0675 15.6141C27.6816 15.3292 29.2596 15.4947 30.6542 16.455C32.0439 17.4122 32.7416 18.7921 32.9336 20.4403C33.054 21.4751 33.0379 21.4772 31.9904 21.4772C30.9954 21.4772 30.9954 21.4772 30.8228 20.5086C30.5335 18.8865 29.4943 17.7831 28.0017 17.5132C26.3411 17.2128 24.8424 18.0068 24.3785 19.4326C23.9016 20.8975 24.3829 22.3437 25.6658 23.2006C26.5776 23.8097 27.6177 24.1672 28.6067 24.6224C29.8208 25.1816 31.0198 25.7548 31.9278 26.7766C33.7744 28.8546 33.6309 32.3129 31.6242 34.236C31.5272 34.3293 31.4211 34.4129 31.3124 34.5066C31.4422 34.6276 31.5599 34.5828 31.6643 34.5831C32.5814 34.5875 33.4988 34.5688 34.4152 34.5945C34.761 34.6042 34.8704 34.4885 34.8209 34.1678C34.8115 34.1062 34.8196 34.0423 34.8196 33.9795C34.8226 28.1519 34.8259 22.3243 34.8293 16.4968C34.8296 15.8459 34.847 15.8292 35.5129 15.8289C35.8898 15.8289 36.2667 15.8289 36.6433 15.8289C37.2845 15.8292 37.3089 15.8526 37.3092 16.4784C37.3092 19.0028 37.3176 21.5273 37.2999 24.0515C37.2975 24.4174 37.3909 24.5043 37.7534 24.5033C41.9615 24.4896 46.1697 24.4896 50.3778 24.503C50.747 24.504 50.8641 24.4294 50.8611 24.0361C50.8417 21.5116 50.8507 18.9871 50.8514 16.4627C50.8517 15.861 50.8855 15.8292 51.4952 15.8289C51.9598 15.8289 52.425 15.8366 52.8895 15.8265C53.1919 15.8202 53.332 15.9576 53.3327 16.2526C53.3327 16.3533 53.3337 16.4536 53.334 16.5543C53.334 22.5324 53.334 28.5108 53.3337 34.4892C53.3337 35.3604 53.3334 35.3604 52.4752 35.3604C52.0731 35.3604 51.6711 35.3584 51.2694 35.3598C51.0196 35.3608 50.8557 35.2825 50.8711 34.9902C50.8798 34.8283 50.8524 34.6651 50.852 34.5025C50.8507 32.0032 50.8453 29.5038 50.8584 27.0047C50.8601 26.6793 50.7828 26.5789 50.444 26.5853C49.251 26.608 48.057 26.6034 46.864 26.5876C46.5757 26.584 46.5325 26.6639 46.5991 26.9264C48.0938 32.8109 49.5821 38.6966 51.0718 44.582C51.0995 44.6911 51.137 44.7984 51.1544 44.9091C51.2072 45.2446 51.048 45.4403 50.7109 45.4443C50.1958 45.45 49.6801 45.4312 49.166 45.4513C48.8396 45.464 48.6901 45.3229 48.6169 45.0198C48.1961 43.2813 47.761 41.5462 47.3459 39.8063C47.2854 39.5518 47.1877 39.4709 46.9218 39.4736C45.4399 39.4883 43.9576 39.4873 42.4753 39.4742C42.2137 39.4719 42.111 39.5455 42.0492 39.8057C41.6371 41.5352 41.1986 43.2586 40.7859 44.9881C40.7043 45.3292 40.5495 45.4774 40.1912 45.4516C39.829 45.4255 39.4631 45.4483 39.0989 45.4453C38.6742 45.4416 38.519 45.2439 38.6243 44.8198C38.8531 43.8988 39.0936 42.9803 39.3257 42.0599C40.6013 36.9973 41.8739 31.9343 43.1555 26.8733C43.2137 26.6438 43.1666 26.5903 42.9418 26.5913C41.1578 26.597 39.3742 26.603 37.5905 26.5873C37.2143 26.584 37.3116 26.8198 37.3112 27.0104C37.3079 32.8881 37.3079 38.7659 37.3072 44.6439C37.3069 45.4459 37.3069 45.4459 36.4922 45.4459C36.1029 45.4459 35.7126 45.4302 35.3242 45.45C34.9476 45.469 34.8159 45.3182 34.8175 44.9423C34.8289 42.6312 34.8229 40.3204 34.8229 38.0093C34.8229 37.6702 34.8112 37.3307 34.8269 36.9922C34.8369 36.7681 34.7734 36.6872 34.5339 36.6875C30.2128 36.6942 25.8916 36.6956 21.5704 36.6859C21.2577 36.6852 21.2694 36.8447 21.2697 37.0605C21.2727 39.5976 21.2717 42.1345 21.2714 44.6717C21.2714 45.4453 21.2707 45.4456 20.5132 45.4459C20.0861 45.4463 19.6587 45.4359 19.2319 45.449C18.9252 45.4583 18.7944 45.3102 18.7817 45.0245C18.7767 44.9118 18.7774 44.7988 18.7774 44.6857C18.7774 38.6826 18.7774 32.6791 18.7777 26.6759C18.7777 26.5381 18.7767 26.399 18.7928 26.2626C18.8175 26.0482 18.9292 25.9197 19.163 25.9211C19.7533 25.9248 20.3436 25.9237 20.9339 25.9268C21.1453 25.9278 21.26 26.0298 21.2594 26.2498C21.2594 26.4003 21.2711 26.5509 21.2711 26.7014C21.2717 29.1757 21.2814 31.65 21.2614 34.1239C21.2584 34.5193 21.3754 34.6109 21.747 34.5942C22.4062 34.5644 23.0674 34.5858 23.7223 34.5858Z"
              fill="#051D8D"
            />
            <path
              d="M60.7589 18.472C60.1164 21.4457 59.399 24.3875 58.6739 27.3277C58.601 27.6224 58.7519 27.6053 58.9435 27.605C60.1111 27.6027 61.2787 27.5933 62.4459 27.6104C62.7844 27.6154 62.8279 27.5331 62.7483 27.2083C62.2299 25.0949 61.7084 22.9818 61.2663 20.8507C61.1017 20.0567 60.9285 19.2647 60.7589 18.472ZM65.9249 35.3604C65.7239 35.3604 65.5229 35.3607 65.3219 35.3604C64.7824 35.359 64.7416 35.3283 64.6122 34.7988C64.2025 33.1215 63.7871 31.4456 63.3918 29.7649C63.3222 29.4699 63.2128 29.3689 62.8958 29.3733C61.4265 29.394 59.9569 29.3877 58.4876 29.3776C58.2452 29.376 58.1475 29.4422 58.088 29.692C57.6806 31.4091 57.2425 33.1189 56.8371 34.8363C56.7471 35.2176 56.5926 35.4052 56.1792 35.3667C55.8431 35.3356 55.5016 35.3627 55.1625 35.3597C54.708 35.356 54.5528 35.151 54.6668 34.6828C54.832 34.0025 55.0093 33.3255 55.1809 32.6469C56.5578 27.2 57.9378 21.7537 59.3044 16.3041C59.3947 15.9429 59.5562 15.8098 59.9245 15.8221C60.6017 15.8455 61.2807 15.8365 61.9586 15.8255C62.258 15.8205 62.4145 15.9355 62.4894 16.2325C64.0326 22.3611 65.5821 28.488 67.1293 34.6155C67.2705 35.1734 67.127 35.3587 66.5654 35.3604C66.352 35.361 66.1383 35.3604 65.9249 35.3604Z"
              fill="#051D8D"
            />
            <path
              d="M11.7072 45.7845C10.1426 45.7681 8.8974 45.4932 7.82614 44.6648C6.5843 43.7042 5.97024 42.3925 5.7388 40.875C5.69364 40.578 5.68027 40.2764 5.65886 39.9764C5.64214 39.7449 5.75385 39.6198 5.98897 39.6188C6.46624 39.6168 6.94351 39.6121 7.42044 39.6188C7.71543 39.6228 7.82413 39.7904 7.84252 40.08C7.886 40.7613 8.03918 41.4195 8.35023 42.0336C9.0382 43.3922 10.3001 43.9912 12.0232 43.7795C13.3911 43.6112 14.4326 42.6875 14.7407 41.3704C15.1012 39.8282 14.5276 38.3526 13.2059 37.4121C12.359 36.8097 11.3811 36.4713 10.4506 36.0375C9.56731 35.6254 8.64789 35.2853 7.86159 34.6866C6.04415 33.3026 5.52709 31.4514 5.99666 29.2975C6.41674 27.3704 7.95724 26.0185 10.0389 25.6971C11.9122 25.4078 13.6811 25.6412 15.1567 26.963C16.3812 28.06 16.8655 29.4968 16.9538 31.0949C16.9715 31.4126 16.8314 31.5875 16.4825 31.5718C16.119 31.5554 15.7527 31.5497 15.3902 31.5735C15.0143 31.5976 14.8788 31.427 14.8494 31.0741C14.7808 30.2464 14.5367 29.4764 14.0226 28.8082C13.0015 27.4801 10.8633 27.1256 9.4643 28.0527C7.74821 29.1898 7.74051 31.8648 9.45393 33.1615C10.254 33.7665 11.2072 34.0755 12.1018 34.495C13.2032 35.011 14.326 35.4793 15.2798 36.2632C18.1421 38.6155 17.7337 43.3791 14.5186 45.0888C13.6601 45.5454 12.6002 45.7865 11.7072 45.7845Z"
              fill="#051D8D"
            />
          </svg>
        </Link>

        {/* <p>
          Lorem Ipsum is simply dummy text of the printing and industry. Lorem
          Ipsum has been the industry'
        </p> */}
      </div>
      <section className="footer_logo_bottom">
        {/* <p>
          <i>Follow Us</i>
        </p> */}
        <div className="footer_logo_bottom_con">
          <a href="https://x.com/shashacloud">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              enable-background="new 0 0 72 72"
              viewBox="0 0 72 72"
              id="twitter-x"
            >
              <switch>
                <g>
                  <path
                    d="M42.5,31.2L66,6h-6L39.8,27.6L24,6H4l24.6,33.6L4,66
			h6l21.3-22.8L48,66h20L42.5,31.2z M12.9,10h8l38.1,52h-8L12.9,10z"
                  ></path>
                </g>
              </switch>
            </svg>
          </a>
          {/* <a href="#">
            <svg
              width="23"
              height="14"
              viewBox="0 0 23 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_260_1419)">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M20.2148 1.89565H14.7305V0.571457H20.2152V1.89565H20.2148ZM11.0802 7.32605C11.4341 7.85882 11.6109 8.50572 11.6109 9.26522C11.6109 10.0506 11.4116 10.7552 11.0059 11.3776C10.7479 11.7894 10.4275 12.1373 10.0425 12.4174C9.60897 12.7413 9.09567 12.9634 8.50558 13.082C7.91361 13.2009 7.27288 13.2609 6.58269 13.2609H0.449219V0.0226288H7.02643C8.6843 0.0488352 9.85965 0.515728 10.5537 1.43266C10.9702 1.99505 11.1765 2.66985 11.1765 3.45421C11.1765 4.26355 10.9677 4.91116 10.5471 5.40318C10.3132 5.67905 9.96763 5.92997 9.51015 6.1565C10.2031 6.40308 10.7289 6.79137 11.0802 7.32605ZM3.58984 5.24187H6.47171C7.06394 5.24187 7.54269 5.13244 7.91142 4.91371C8.27989 4.69534 8.46375 4.30714 8.46375 3.74976C8.46375 3.13396 8.2203 2.72524 7.73224 2.52852C7.31272 2.39185 6.77596 2.32146 6.12465 2.32146H3.58984V5.24187ZM8.74124 9.07533C8.74124 8.38767 8.4521 7.91226 7.87498 7.65718C7.55225 7.5122 7.09691 7.4381 6.51308 7.43279H3.58984V10.9607H6.46784C7.0591 10.9607 7.51673 10.8855 7.84699 10.7286C8.44258 10.44 8.74124 9.89076 8.74124 9.07533ZM22.2522 6.92258C22.3185 7.35569 22.3485 7.98409 22.3363 8.80545H15.2335C15.2727 9.75845 15.6112 10.4249 16.2531 10.8063C16.6402 11.0454 17.1095 11.1622 17.6591 11.1622C18.2386 11.1622 18.7109 11.0198 19.0745 10.7271C19.2726 10.5719 19.4474 10.3529 19.5985 10.0765H22.2019C22.1337 10.6394 21.8202 11.2103 21.2569 11.7904C20.3841 12.7125 19.1601 13.1748 17.588 13.1748C16.2894 13.1748 15.1449 12.7849 14.1515 12.0078C13.1613 11.2281 12.6641 9.96344 12.6641 8.20916C12.6641 6.56411 13.1105 5.30497 14.0064 4.42854C14.9056 3.55048 16.066 3.11345 17.4964 3.11345C18.3442 3.11345 19.1085 3.26077 19.7904 3.55692C20.4701 3.85337 21.0318 4.31991 21.4742 4.96115C21.8746 5.52583 22.1321 6.17876 22.2522 6.92258ZM19.6881 7.1694C19.6403 6.51044 19.414 6.01166 19.0064 5.6708C18.6022 5.329 18.0973 5.15739 17.4948 5.15739C16.839 5.15739 16.3327 5.34082 15.9729 5.70132C15.6107 6.0611 15.3853 6.55018 15.293 7.16945H19.6881V7.1694Z"
                  fill="#767676"
                />
              </g>
              <defs>
                <clipPath id="clip0_260_1419">
                  <rect
                    width="21.8879"
                    height="13.2383"
                    fill="white"
                    transform="translate(0.449219 0.0226288)"
                  />
                </clipPath>
              </defs>
            </svg>
          </a> */}

          <a href=" https://www.instagram.com/shasha.cloud?igsh=ZDZwaGM3ZnN6ZGt6">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="2500"
              height="2500"
              viewBox="0 0 2476 2476"
              id="instagram"
            >
              <path d="M825.4 1238c0-227.9 184.7-412.7 412.6-412.7 227.9 0 412.7 184.8 412.7 412.7 0 227.9-184.8 412.7-412.7 412.7-227.9 0-412.6-184.8-412.6-412.7m-223.1 0c0 351.1 284.6 635.7 635.7 635.7s635.7-284.6 635.7-635.7-284.6-635.7-635.7-635.7S602.3 886.9 602.3 1238m1148-660.9c0 82 66.5 148.6 148.6 148.6 82 0 148.6-66.6 148.6-148.6s-66.5-148.5-148.6-148.5-148.6 66.5-148.6 148.5M737.8 2245.7c-120.7-5.5-186.3-25.6-229.9-42.6-57.8-22.5-99-49.3-142.4-92.6-43.3-43.3-70.2-84.5-92.6-142.3-17-43.6-37.1-109.2-42.6-229.9-6-130.5-7.2-169.7-7.2-500.3s1.3-369.7 7.2-500.3c5.5-120.7 25.7-186.2 42.6-229.9 22.5-57.8 49.3-99 92.6-142.4 43.3-43.3 84.5-70.2 142.4-92.6 43.6-17 109.2-37.1 229.9-42.6 130.5-6 169.7-7.2 500.2-7.2 330.6 0 369.7 1.3 500.3 7.2 120.7 5.5 186.2 25.7 229.9 42.6 57.8 22.4 99 49.3 142.4 92.6 43.3 43.3 70.1 84.6 92.6 142.4 17 43.6 37.1 109.2 42.6 229.9 6 130.6 7.2 169.7 7.2 500.3 0 330.5-1.2 369.7-7.2 500.3-5.5 120.7-25.7 186.3-42.6 229.9-22.5 57.8-49.3 99-92.6 142.3-43.3 43.3-84.6 70.1-142.4 92.6-43.6 17-109.2 37.1-229.9 42.6-130.5 6-169.7 7.2-500.3 7.2-330.5 0-369.7-1.2-500.2-7.2M727.6 7.5c-131.8 6-221.8 26.9-300.5 57.5-81.4 31.6-150.4 74-219.3 142.8C139 276.6 96.6 345.6 65 427.1 34.4 505.8 13.5 595.8 7.5 727.6 1.4 859.6 0 901.8 0 1238s1.4 378.4 7.5 510.4c6 131.8 26.9 221.8 57.5 300.5 31.6 81.4 73.9 150.5 142.8 219.3 68.8 68.8 137.8 111.1 219.3 142.8 78.8 30.6 168.7 51.5 300.5 57.5 132.1 6 174.2 7.5 510.4 7.5 336.3 0 378.4-1.4 510.4-7.5 131.8-6 221.8-26.9 300.5-57.5 81.4-31.7 150.4-74 219.3-142.8 68.8-68.8 111.1-137.9 142.8-219.3 30.6-78.7 51.6-168.7 57.5-300.5 6-132.1 7.4-174.2 7.4-510.4s-1.4-378.4-7.4-510.4c-6-131.8-26.9-221.8-57.5-300.5-31.7-81.4-74-150.4-142.8-219.3C2199.4 139 2130.3 96.6 2049 65c-78.8-30.6-168.8-51.6-300.5-57.5-132-6-174.2-7.5-510.4-7.5-336.3 0-378.4 1.4-510.5 7.5"></path>
            </svg>
          </a>
          <a href="https://www.linkedin.com/company/shasha-digital-signage/">
            <svg
              width="20"
              height="18"
              viewBox="0 0 20 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M19.2355 10.4903V17.1127H15.2572V10.9253C15.2572 9.3785 14.7101 8.31505 13.268 8.31505C12.174 8.31505 11.5275 9.04013 11.2291 9.71688C11.1296 9.95857 11.0799 10.2969 11.0799 10.6353V17.1127H7.10156C7.10156 17.1127 7.15129 6.62319 7.10156 5.55973H11.0799V7.20326C11.0799 7.20326 11.0799 7.25159 11.0302 7.25159H11.0799V7.20326C11.6269 6.42984 12.5221 5.2697 14.6604 5.2697C17.2463 5.2697 19.2355 6.96156 19.2355 10.4903ZM3.02298 0.000167847C1.68028 0.000167847 0.785156 0.870268 0.785156 1.98206C0.785156 3.09385 1.63056 3.96396 2.97324 3.96396H3.02298C4.4154 3.96396 5.2608 3.09386 5.2608 1.98206C5.21107 0.870268 4.36567 0.000167847 3.02298 0.000167847ZM0.984375 17.1127H4.913V5.55974H0.984375V17.1127Z"
                fill="#1E1E1E"
              />
            </svg>
          </a>
        </div>
      </section>
    </div>
  );
};

const FooterLinks = ({ title, links }) => {
  return (
    <div className="footer_links">
      <div className="footer_links_CON">
        <h4>{title}</h4>
        {/* <div className="footer_links_con">
          {links &&
            links.map((item) => (
              <Link key={item.title} to={item.href}>
                {item.title}
              </Link>
            ))}
        </div> */}
        <div class="footer_links_con">
          <div>
            <Link to="/">Home</Link>
            <Link to="/how-it-works">How It Works</Link>
          </div>{" "}
          <div>
            <Link to="/use-cases"> Key Industries </Link>

            <Link to="/key-features">Features &amp; Apps</Link>
          </div>{" "}
          <div>
            <Link to="/players">Players</Link>
            <Link to="/pricing">Pricing</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

const FooterContacts = () => {
  return (
    <div className="footer_larg footer_conatct ">
      <h4>Contact Details</h4>
      <div>
        <a
          style={{ textDecoration: "none" }}
          href="https://maps.app.goo.gl/tWUoJ6Aj2mpZ9SoYA?g_st=iw"
        >
          <div className="footer_conatct_item">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
            >
              <g clip-path="url(#clip0_260_1378)">
                <path
                  d="M19.25 9.16659C19.25 15.5833 11 21.0833 11 21.0833C11 21.0833 2.75 15.5833 2.75 9.16659C2.75 6.97855 3.61919 4.88013 5.16637 3.33296C6.71354 1.78578 8.81196 0.91659 11 0.91659C13.188 0.91659 15.2865 1.78578 16.8336 3.33296C18.3808 4.88013 19.25 6.97855 19.25 9.16659Z"
                  stroke="#051D8D"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M11 11.9166C12.5188 11.9166 13.75 10.6854 13.75 9.16659C13.75 7.64781 12.5188 6.41659 11 6.41659C9.48122 6.41659 8.25 7.64781 8.25 9.16659C8.25 10.6854 9.48122 11.9166 11 11.9166Z"
                  stroke="#051D8D"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_260_1378">
                  <rect width="22" height="22" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <p>10 9WC 523, Dubai Free-zone, Dubai, UAE.</p>
          </div>
        </a>

        <a href="mailto:admin@shasha.cloud" className="footer_conatct_item">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M4 3.99992H20C21.1 3.99992 22 4.89992 22 5.99992V17.9999C22 19.0999 21.1 19.9999 20 19.9999H4C2.9 19.9999 2 19.0999 2 17.9999V5.99992C2 4.89992 2.9 3.99992 4 3.99992Z"
              stroke="#051D8D"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M22 5.99992L12 12.9999L2 5.99992"
              stroke="#051D8D"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <p> admin@shasha.cloud</p>
        </a>

        {/* <a href="#" className="footer_conatct_item">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
          >
            <g clip-path="url(#clip0_260_1388)">
              <path
                d="M23.8881 17.3907V20.3907C23.8892 20.6692 23.8322 20.9449 23.7206 21.2001C23.6091 21.4552 23.4454 21.6843 23.2402 21.8726C23.035 22.0609 22.7927 22.2042 22.5289 22.2934C22.265 22.3827 21.9855 22.4158 21.7081 22.3907C18.631 22.0564 15.6751 21.0049 13.0781 19.3207C10.6619 17.7854 8.61345 15.7369 7.07812 13.3207C5.38809 10.7119 4.33636 7.74172 4.00812 4.65072C3.98313 4.37419 4.01599 4.09548 4.10462 3.83235C4.19324 3.56921 4.33569 3.32741 4.52288 3.12234C4.71008 2.91728 4.93792 2.75343 5.19191 2.64125C5.44589 2.52906 5.72046 2.47099 5.99812 2.47072H8.99812C9.48342 2.46595 9.95391 2.6378 10.3219 2.95426C10.6898 3.27071 10.9302 3.71017 10.9981 4.19072C11.1247 5.15079 11.3596 6.09345 11.6981 7.00072C11.8327 7.35865 11.8618 7.74764 11.782 8.1216C11.7023 8.49557 11.517 8.83883 11.2481 9.11072L9.97812 10.3807C11.4017 12.8843 13.4746 14.9572 15.9781 16.3807L17.2481 15.1107C17.52 14.8419 17.8633 14.6566 18.2372 14.5768C18.6112 14.4971 19.0002 14.5262 19.3581 14.6607C20.2654 14.9993 21.2081 15.2341 22.1681 15.3607C22.6539 15.4293 23.0975 15.6739 23.4146 16.0482C23.7318 16.4225 23.9003 16.9003 23.8881 17.3907Z"
                stroke="#051D8D"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_260_1388">
                <rect
                  width="24"
                  height="24"
                  fill="white"
                  transform="translate(0 0.470627)"
                />
              </clipPath>
            </defs>
          </svg>
          <p>(+20) 011-xxxx-xxxx-xxx</p>
        </a> */}
      </div>

      {/* <form>
        <h4>Newsletter</h4>
        <div>
          <input type="email" placeholder="Email address" required />
          <button type="submit">SUBSCRIBE</button>
        </div>
      </form> */}
    </div>
  );
};
